// 这个文件是创建活动，依赖form-activty，编辑活动也依赖这个文件
import FormActivity from '@/components/edit-activity-plan/form-activity';
import React from 'react';
import { Form, Input, Button, message, Select } from 'antd';
import { withRouter } from 'react-router-dom';
import useCommitForm from './useCommitForm';
import validator from '@/common/validator';
import { ACTIVITY_TYPES } from '@/constants/activity-type';
import useSlideMenuCollapsedChange from '@/hooks/useSlideMenuCollapsedChange';
import provideActivityLink from '@/components/provide-activity-link';
import utils from '@/common/utils';

import './index.less';

const { Option } = Select;

function _FormCreateActivity(props) {
  // history有问题
  const {
    FormFooter = DefaultFormFooter,
    onSuccess = () => null,
    onCancel = () => props.history.go(-1),
    onFailed = () => null,
  } = props;

  const [statusPush, pushFormData] = useCommitForm(false);
  const { pageType } = provideActivityLink.useActivityLink();

  function commitForm(values, success = () => {}, failed = () => {}, setErrMsgFromBackEnd) {
    // 只有在频道活动的时候才要求channelId
    if (pageType === provideActivityLink.themeActivityType.channel) {
      values.channelCode = utils.getQuery('channelId');
    }

    pushFormData(values)
      .then((res) => {
        // formInstance.current.resetFields()
        success(res);
        onSuccess(res);
      })
      .catch((res) => {
        if (res && res.ret === '1') {
          // 设置后端校验错误展示在页面上
          setErrMsgFromBackEnd(res.msg);
          // info(res.msg)
        }
        failed();
        onFailed();
      });

  }

  // 发布活动
  function publishActivity(values, setErrMsgFromBackEnd) {
    // 发布活动
    values.status = 1;
    values.activityVersion = 1; // 传统主题活动

    message.loading('活动保存中...');

    commitForm(
      values,
      () => {
        message.destroy();
        message.success('活动创建成功！');
      },
      () => {
        message.destroy();
        message.error('活动创建失败！');
      },
      setErrMsgFromBackEnd
    );
  }

  function ActivityName() {
    return (
      <Form.Item
        label="活动名称"
        name="activityName"
        validateFirst
        rules={[
          {
            required: true,
            message: '活动名称不能为空',
          },
          {
            max: 20,
            message: '活动名称不能超过20个字符',
          },
          {
            validator: validator.validateActivityName,
          },
        ]}
      >
        <Input placeholder="请输入20字以内的名称" />
      </Form.Item>
    );
  }

  function ActivityType() {
    return (
      <Form.Item
        label="活动类型"
        name="activityType"
        validateFirst
        required
        rules={[
          {
            required: true,
            message: '请选择活动类型',
          },
        ]}
      >
        <Select placeholder="请选择活动类型">
          {ACTIVITY_TYPES.map((item) => (
            <Option key={item.val} value={item.val}>
              {item.title}
            </Option>
          ))}
        </Select>
      </Form.Item>
    );
  }

  function _FormFooter() {
    return <FormFooter statusPush={statusPush} onCancel={onCancel} />;
  }

  function onFinish(values, setErrMsgFromBackEnd) {
    values.category = values.category.toString();
    publishActivity(values, setErrMsgFromBackEnd);
  }

  return (
    <FormActivity
      onFinish={onFinish}
      ActivityName={ActivityName}
      FormFooter={_FormFooter}
      ActivityType={ActivityType}
      // initialData={props.initialData}
    />
  );
}

function DefaultFormFooter(props) {
  const { statusPush, onCancel } = props;
  const [className] = useSlideMenuCollapsedChange('', 'adapter-slide-menu-padding');
  return (
    <Form.Item className="bottom-footer" style={{ height: 0, marginBottom: 0 }}>
      <div className={'bottom-footer-btn-wrap ' + 'bottom-footer-btn-wrap edit-activity-footer-wrap ' + className}>
        <Button className="btn-bottom-footer-cancel" onClick={onCancel} disabled={statusPush.isIng}>
          取消
        </Button>
        <div>
          <Button disabled={statusPush.isIng} type="primary" htmlType="submit">
            创建并下一步
          </Button>
        </div>
      </div>
    </Form.Item>
  );
}

function InResourceApplyFormFooter(props) {
  const { statusPush, onCancel } = props;
  return (
    <Form.Item className="bottom-footer bottom-footer-in-resource-apply">
      <Button onClick={onCancel} disabled={statusPush.isIng}>
        取消
      </Button>
      <Button disabled={statusPush.isIng} type="primary" htmlType="submit">
        发布活动并下一步
      </Button>
    </Form.Item>
  );
}

const FormCreateActivity = withRouter(_FormCreateActivity);

const formHOCInjectFooter = (FormFooter) => (props) => <FormCreateActivity {...props} FormFooter={FormFooter} />;

export const FormInResourceApply = formHOCInjectFooter(InResourceApplyFormFooter);

export default formHOCInjectFooter();
